import comp from "./ToggleSwitchList";
export default comp;
